import {AppSettingsRepo, SettingsKeys} from "../settings/IAppSettingsRepo";

const unregisterDevice = async () => {
    await AppSettingsRepo.del(SettingsKeys.syncUUID);
    await AppSettingsRepo.del(SettingsKeys.syncDevice);
}

export default unregisterDevice;